import styled, { createGlobalStyle } from 'styled-components'

interface AppBodyProps {
  $isSportsBet: boolean;
  $ihgWrapper?: boolean;
  $isMobile?: boolean;
  $isNewIHGPage?: boolean;
}

export const AppBody = styled.div<AppBodyProps>`
  padding: ${(p) => 
    p.$isSportsBet || ((p.$ihgWrapper || p.$isNewIHGPage) && p.$isMobile) ? '0' : '0 16px'};
  padding-top: ${(p) => 
    !p.$ihgWrapper && !p.$isSportsBet && !(p.$isNewIHGPage && p.$isMobile) ? '15px' : '0'};
  padding-bottom: ${(p) => p.$ihgWrapper ? '0' : '70px'};
`
export const GlobalStyles = createGlobalStyle`
  @keyframes modalFadeIn {
    from {
      opacity: 0;
      transform: translateY(20%);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes modalFadeInCenter {
    from {
      opacity: 0;
      transform: translate(-50%, -50%) scale(0.9);
    }
    to {
      opacity: 1;
      transform: translate(-50%, -50%) scale(1);
    }
  }

  @keyframes overlayFadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`